/* eslint jsx-a11y/no-static-element-interactions: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import './popoverListItem.scss';

const PopoverListItem = ({
    isSelected,
    text,
    onSelect,
}) => (
    <div
        className={classNames(
            'ui-popoverList__item',
            'cm-popoverList__popoverLink',
            { 'cm-popoverList__popoverLink_selected': isSelected },
        )}
        onClick={onSelect}
    >
        <span
            className={classNames(
                'ui-popoverList__label',
                'cm-popoverList__popoverLabel',
            )}
        >
            { text }
        </span>
        <span className="ui-popoverList__icon">
            <Svg
                isInlined
                iconName="tick"
                size="Medium"
            />
        </span>
    </div>
);

PopoverListItem.defaultProps = {
    text: null,
};

PopoverListItem.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    text: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
};

export default PopoverListItem;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/PopoverListItem/PopoverListItem.jsx